<template>
  <div class="contents main">
      <section>
        <h2 class="page_title">접수현황</h2>
        <article>
          <ul class="step">
            <li v-for="(item, index) in intakeStausList" :key="index">
              <div class="info">
                <div class="count">{{ item.cnt }}</div>
                <div class="label">{{ item.dtl_code_nm }}</div>
              </div>
              <b-icon icon="chevron-right"></b-icon>
            </li>
          </ul>
        </article>
      </section>
      <div class="dash_contents">
        <section class="medi">
          <h2 class="page_title">약재 현황 <router-link to="/admin/medicine/MedicineStockMngt" class="title_more">더보기</router-link></h2>
          <article>
            <ul class="simple_title">
              <li>약재</li>
              <li>원산지</li>
              <li>재고량</li>
            </ul>
            <ul class="simple_grid">
                <li v-for="( medi, index ) in medicineStockList" :key="index">
                  <p class="ell"> {{ medi.med_hrb_nm }}</p>
                  <p class="ell"> {{ medi.org_plce_nm }}</p>
                  <p class="ell"> {{ medi.stock_qnty }}</p>
                </li>
            </ul>
          </article>
        </section>
        <section class="wrapper">
          <h2 class="page_title">포장지 현황 <router-link to="/admin/wrapper/WrapperWrhsMngt" class="title_more">더보기</router-link></h2>
          <article>
            <ul class="simple_title">
              <li>포장종류</li>
              <li>포장지</li>
              <li>재고량</li>
            </ul>
              <ul class="simple_grid">
                <li v-for="( wra, index ) in wrapperStockList" :key="index">
                  <p class="ell">{{ wra.wrapper_class_nm }}</p>
                  <p class="ell">{{ wra.wrapper_nm }} </p>
                  <p class="ell">{{ wra.stock_qnty }}</p>
                </li>
              </ul>
          </article>
        </section>
        <section class="notice">
          <h2 class="page_title">공지사항 <router-link to="/admin/board/noticeMngt" class="title_more">더보기</router-link></h2>
          <article>
            <ul>
              <li></li>
            </ul>
            <ul class="simple_grid">
              <li v-for="( noti, index ) in noticeList" :key="index">
                <p class="title ell al">{{ noti.board_notice_title }}</p>
                <p class="date ar">{{ noti.reg_dt }}</p>
              </li>
            </ul>
          </article>
        </section>
      </div>
    </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'AdminMain',
    data() {
      return {
        intakeStausList: [],
        medicineStockList: [],
        wrapperStockList: [],
        noticeList: [],
      }
    },
    mounted(){
        this.fn_intake_status();    // 재고현황 조회
        this.fn_medicine_stock();   // 약재현황 조회
        this.fn_wrapper_stock();    // 포장지 재고 현황
        this.fn_notice();           // 공지사항 조회

    },
    methods : {
      fn_intake_status(){
          axios
              .post("/api/admin/dashboard/getIntakeStaus")
              .then((res) => {
                  this.intakeStausList = res.data.intakeStausList;
              })
              .catch((err) => console.log(err));
      },
      fn_medicine_stock(){
        axios
            .post("/api/admin/dashboard/getMedicineStock")
            .then((res) => {
              this.medicineStockList = res.data.medicineStockList;
            })
            .catch((err) => console.log(err));
      },
      fn_wrapper_stock(){
        axios
            .post("/api/admin/dashboard/getWrapperStock")
            .then((res) => {
              this.wrapperStockList = res.data.wrapperStockList;
            })
            .catch((err) => console.log(err));
      },
      fn_notice(){
        axios
            .post("/api/admin/dashboard/getNoticeList")
            .then((res) => {
              this.noticeList = res.data.noticeList;
            })
            .catch((err) => console.log(err));
      },

    }
  }
</script>